<template>

    <div>

        <!--
        <span class="select is-medium">
            <select v-model="email.recipients">
                <option :value="null">{{ $t('EMAIL-SEND_EMAIL-SELECT_BOX-CHOOSE_MANUFACTURER') }}</option>
                <option :value="null">{{ $t('EMAIL-SEND_EMAIL-SELECT_BOX-ALL_MANUFACTURERS') }}</option>
                <option v-for="(manufacturer, index) in manufacturers" :value="manufacturer.id">{{ manufacturer.name }}</option>
            </select>
        </span>
        -->

        <div class="box">

            <!-- TEMPLATES -->
            <div class="control is-horizontal">
                <div class="control-label">
                    <label-name labelKey="EMAIL-SEND_EMAIL-TEMPLATE"></label-name>
                </div>
                <div class="control">
                    <span class="select is-medium">
                        <select id="template" v-model="selectedTemplate" v-on:change="setTemplate()"> <!-- v-on:change="setTemplate($event) -->
                            <option :value="null">{{ $t('EMAIL-SEND_EMAIL-SELECT_BOX-CHOOSE_TEMPLATE') }}</option>
                            <option v-for="(template, index) in templates" :value="template">{{ $t('EMAIL-SEND_EMAIL-SELECT_BOX-' + template.name) }} {{ template.id }}</option>
                        </select>
                    </span>
                </div>
            </div>
            <br  />
            <!-- SUBJECT -->
            <div class="control is-horizontal">
                <div class="control-label">
                    <label-name labelKey="EMAIL-SEND_EMAIL-SUBJECT"></label-name>
                </div>
                <div class="control">
                    <input type="text" id="EMAIL-SEND_EMAIL-SUBJECT" class="input is-medium" v-model="email.subject">
                </div>
            </div>

            <!-- BODY -->
            <div class="control is-horizontal">
                <div class="control-label">
                    <label-name labelKey="EMAIL-SEND_EMAIL-BODY"></label-name>
                </div>
                <div class="control">
                    <textarea type="text" id="EMAIL-SEND_EMAIL-BODY" class="textarea is-medium isLarge" v-model="email.body"></textarea>
                </div>
            </div>

            <!-- SIGNATUR -->
            <div class="control is-horizontal">
                <div class="control-label">
                    <label-name labelKey="EMAIL-SEND_EMAIL-SIGNATURE"></label-name>
                </div>
                <div class="control">
                    <textarea type="text" id="EMAIL-SEND_EMAIL-SIGNATURE" class="textarea is-medium" v-model="email.signature"></textarea>
                </div>
            </div>


            <!-- TEST EMAIL -->
            <div class="control is-horizontal">
                <div class="control-label">
                    <label-name labelKey="EMAIL-SEND_EMAIL-TEST_EMAIL"></label-name>
                </div>
                <div class="control">
                    <input type="text" id="EMAIL-SEND_EMAIL-TEST_EMAIL" class="input is-medium" v-model="testRecipient">
                </div>
            </div>

            <!-- KOPIE EMAIL -->
            <div class="control is-horizontal">
                <div class="control-label">
                    <label-name labelKey="EMAIL-SEND_EMAIL-SEND_CC"></label-name>
                </div>
                <div class="control">
                    <input type="text" id="EMAIL-SEND_EMAIL-SEND_CC" class="input is-medium" v-model="email.cc">
                </div>
            </div>

            <div class="control is-horizontal">

                <div class="control-label"></div>

                <div class="control is-clearfix">

                    <div class="" style="float:right;">

                        <button :class="isSending ? 'is-loading' : ''" class="button is-normal is-success" @click="sendEmail('test')">
                            <span class="icon is-medium"><i class="icon-ak-nachricht"></i></span><br />
                            <lang labelKey="EMAIL-SEND_EMAIL-SEND_TEST_EMAIL"></lang>
                        </button>

                        <button :class="isSending ? 'is-loading' : ''" class="button is-normal is-success" @click="sendEmail()">
                            <span class="icon is-medium"><i class="icon-ak-nachricht"></i></span><br />
                            <lang labelKey="EMAIL-SEND_EMAIL-SEND_EMAIL"></lang>
                        </button>
                    </div>

                </div>
            </div>



        </div>

    </div>


</template>



<script>
export default {

    props: ['recipients'],

	data() {

		return {
            // manufacturers: [],
            templates: [],
            selectedTemplate: 0,
            isSending: false,
            testRecipient: '',
            showTestEmailBtn: false,
            email: {
                to: '',
                subject: '',
                body: '',
                from: 'datenbank@apothekenkatalog.at',
                replyTo: 'datenbank@apothekenkatalog.at',
                cc: '',
                bcc: 'datenbank@apothekenkatalog.at',
                signature: ''
            }
        }

    },

    created() {

        // this.fetchManufacturers();
        this.fetchTemplates();

    },


    mounted() {

        console.log("RECIPIENTS: ", this.recipients);

    },

    watch: {

        testEmail() {


        }


    },


    computed: {


    },


    methods: {

        setTemplate() {

            if(this.selectedTemplate != null) {

                this.email.subject = this.selectedTemplate.subject;
                this.email.body = this.selectedTemplate.body;

            }

        },


        /*
        fetchManufacturers() {

			var self = this;

			this.axios.get(self.$config.api + 'manufacturer?orderBy=name')
				.then(function (response) {
					self.manufacturers = response.data.manufacturer;
					self.isLoading = false;
				})
				.catch(function (error) {
					// self.isLoading = false;
					console.log(error);
				});

		},
        */


        fetchTemplates() {

            this.isLoading = true;
            var self = this;

            // fetch data
            this.axios.get(this.$config.api + 'mailTemplate')
                .then(function(response) {
					self.templates = response.data.mailTemplate;
                    self.isLoading = false;
                }).catch(function(error) {
                    self.isLoading = false;
                    console.log('Error: ', error.message);
                });

        },


        sendEmail(type) {

            var recipients = "";

            // if test email should be sent
            if(type == "test") {

                // and no test Email address was given ...
                if(this.testRecipient.length != '') {

                    this.$notify.open({content: this.$t('MSG-ERROR-EMAIL_SENDING-NO_TESTEMAIL_GIVEN'), type: 'warning'});
                    return false;

                } else {

                    // validate the test email ...
        			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        		    if(!re.test(this.testRecipient)) {
        				this.$notify.open({content: this.$t('MSG-ERROR-USER-EMAIL_NOT_VALIDE'), type: 'warning'});
        				return false;
        			}

                    recipients = this.testRecipient;

                }

            // otherwise check if recipientlist was given ...
            } else {

                // if no recipientlist was given ...
                if(this.recipients.length == 0) {
                    this.$notify.open({content: this.$t('MSG-ERROR-EMAIL_SENDING-NO_RECIPIENTS_GIVEN'), type: 'warning'});
                    return false;
                }

                recipients = [this.recipients].join(';');

            }


            // prepare our sendData object
            var sendData = {
                to: recipients,
                subject: this.email.subject,
                htmlBody: this.email.body + '<br /><br />---<br />' + this.email.signature,
                from: '',
                replyTo: '',
                cc: this.email.cc,
                bcc: 'matthias@jumptomorrow.com'
            }

            console.log("SEND DATA: ", sendData);

            return;


            var self = this;
            this.isSending = true;

			this.axios.post(this.$config.api+'mail/sendMail', sendData)
				.then(function(response) {
					self.isSending = false;
					self.$notify.success({content: self.$t('MSG-SUCCESS-EMAIL_SUCCESSFULLY_SENT')});
				}).catch(function(error) {
					self.isSending = false;
					self.$notify.open({content: self.$t('MSG-ERROR-EMAIL_SENDING') + ': ' + error.message, type: 'danger'});
					console.log(error);
				});

            /*
            Parameter:

            to (recipientEmail)
            subject
            htmlBody
            from
            replyTo
            cc (strichkomma-separierte liste von email-Adressen)
            bcc (strichkomma-separierte liste von email-Adressen)
            */


        }



    },


}


</script>



<style scoped>
    textarea.isLarge {
        min-height: 500px;
    }
</style>
